import { render } from "./AllinCity.vue?vue&type=template&id=50016ac0"
import script from "./AllinCity.vue?vue&type=script&lang=js"
export * from "./AllinCity.vue?vue&type=script&lang=js"

import "./AllinCity.vue?vue&type=style&index=0&id=50016ac0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__